import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../services/configuration.service';

@Injectable({
    providedIn: 'root',
})
export class ProductHttpService {
    constructor(private configurations: ConfigurationService, private http: HttpClient) {}

    getAllProducts(): Observable<any> {
        return this.http.get<any>(`${this.configurations.baseUrl}/api/product/getAllProducts`);
    }

    getProductById(productId: any): Observable<any> {
        return this.http.get<any>(`${this.configurations.baseUrl}/api/product/getProductById`, { params: { productId: productId } });
    }

    newProduct(product: any): Observable<any> {
        return this.http.post<any>(`${this.configurations.baseUrl}/api/product/newProduct`, product);
    }

    editProduct(product: any): Observable<any> {
        return this.http.put<any>(`${this.configurations.baseUrl}/api/product/editProduct`, product);
    }

    deleteProduct(productId: any): Observable<any> {
        return this.http.delete<any>(`${this.configurations.baseUrl}/api/product/deleteProduct`, { params: { productId: productId } });
    }

    togglePublishProduct(productId: any, value: any): Observable<any> {
        return this.http.put<any>(
            `${this.configurations.baseUrl}/api/product/togglePublishProduct`,
            {},
            {
                params: { productId: productId, value: value },
            }
        );
    }
}
